import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const PrivacyPage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-233">
      <div className="container mx-auto px-4 py-16 max-w-4xl" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-235">
          <div className="flex justify-center mb-10" data-id="element-236">
            <Link to="/" data-id="element-237">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FoTH3xeKncC1VAra4Rj1n/partners516.png" alt="516 Partners Logo" className="h-12 w-auto" data-id="element-238" />
            </Link>
          </div>
          <h1 className="typekit-heading text-3xl md:text-4xl text-center text-white mb-10" data-id="element-239">
            Privacy Policy
          </h1>
          <div className="text-gray-300 libre-caslon-text-regular space-y-8" data-id="element-240">
            <div className="mb-6" data-id="element-241">
              <p className="text-gray-400" data-id="element-242">
                <strong data-id="element-243">Effective Date:</strong> October 21, 2025
                <br data-id="element-244" />
                <strong data-id="element-245">Company Name:</strong> 516 Partners
                <br data-id="element-246" />
                <strong data-id="element-247">Website:</strong> https://516partners.com
                <br data-id="element-248" />
                <strong data-id="element-249">Contact:</strong> info@516partners.com
              </p>
            </div>
            <div className="mb-6" data-id="element-250">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-251">
                1. Introduction
              </h2>
              <p className="leading-relaxed" data-id="element-252">
                Your privacy is important to us. This Privacy Policy explains
                how 516 Partners collects, uses, and protects the information
                you provide when you interact with our website, advertisements,
                and services related to our Exit Readiness Assessment.
              </p>
            </div>
            <div className="mb-6" data-id="element-253">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-254">
                2. Information We Collect
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-255">We may collect:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-256">
                <li data-id="element-257">
                  <strong className="text-white" data-id="element-258">Personal Information:</strong>{' '}
                  Name, email address, phone number, and business name when you
                  apply or submit a form.
                </li>
                <li data-id="element-259">
                  <strong className="text-white" data-id="element-260">Business Information:</strong>{' '}
                  Details about your clinic or company such as revenue range,
                  industry, and goals, used solely to evaluate your readiness
                  for a potential sale.
                </li>
                <li data-id="element-261">
                  <strong className="text-white" data-id="element-262">Technical Information:</strong>{' '}
                  IP address, browser type, device identifiers, and cookies to
                  improve your browsing experience and analyze performance.
                </li>
              </ul>
            </div>
            <div className="mb-6" data-id="element-263">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-264">
                3. How We Use Your Information
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-265">
                We use your information to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-266">
                <li data-id="element-267">
                  Deliver assessments, reports, and related communications.
                </li>
                <li data-id="element-268">Contact you about next steps or relevant updates.</li>
                <li data-id="element-269">
                  Send educational materials and offers related to business
                  valuation, growth, and exit readiness.
                </li>
                <li data-id="element-270">Improve our website and marketing performance.</li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-271">
                516 Partners does not sell or rent your information to any third
                party.
              </p>
            </div>
            <div className="mb-6" data-id="element-272">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-273">
                4. Sharing Information
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-274">
                We may share information with:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-275">
                <li data-id="element-276">
                  Trusted vendors who provide services like CRM, email, or
                  analytics tools to support delivery of our services.
                </li>
                <li data-id="element-277">
                  Legal authorities when required by law or to protect our
                  rights.
                </li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-278">
                All partners are bound by confidentiality and data-protection
                agreements.
              </p>
            </div>
            <div className="mb-6" data-id="element-279">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-280">
                5. Cookies
              </h2>
              <p className="leading-relaxed" data-id="element-281">
                Our website uses cookies and similar technologies to understand
                user behavior and enhance performance. You can disable cookies
                in your browser settings if you prefer.
              </p>
            </div>
            <div className="mb-6" data-id="element-282">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-283">
                6. Data Security
              </h2>
              <p className="leading-relaxed" data-id="element-284">
                We take commercially reasonable steps to protect your
                information from unauthorized access, loss, or misuse. However,
                no online transmission is completely secure, and you share data
                at your own risk.
              </p>
            </div>
            <div className="mb-6" data-id="element-285">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-286">
                7. Your Rights
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-287">You may request to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-288">
                <li data-id="element-289">Access, correct, or delete your personal data.</li>
                <li data-id="element-290">Opt out of marketing communications at any time.</li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-291">
                To exercise your rights, contact us at info@516partners.com.
              </p>
            </div>
            <div className="mb-6" data-id="element-292">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-293">
                8. Updates to This Policy
              </h2>
              <p className="leading-relaxed" data-id="element-294">
                We may revise this policy periodically. Updates will be posted
                to this page with a new effective date. Continued use of our
                services after updates constitutes acceptance of the revised
                policy.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-295">
            <Link to="/" className="text-[#ffdf07] hover:underline" data-id="element-296">
              Return to Home
            </Link>
          </div>
        </motion.div>
      </div>
      <footer className="border-t border-gray-800 py-8 px-4 mt-16" data-id="element-297">
        <div className="max-w-4xl mx-auto text-center" data-id="element-298">
          <p className="text-gray-400 text-sm mb-4" data-id="element-299">
            © 2025 516 Partners LLC. All rights reserved.
          </p>
          <div className="flex justify-center space-x-4" data-id="element-300">
            <Link to="/privacypage" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-301">
              Privacy Policy
            </Link>
            <span className="text-gray-600" data-id="element-302">|</span>
            <Link to="/termsofservice" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-303">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>;
};
export default PrivacyPage;